import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import TheAlchemyOfCoffee from "./sections/TheAlchemyOfCoffee";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Header />
      <FrequentlyAskedQuestions />
      <TheAlchemyOfCoffee />
      <Footer />
    </div>;
}